import { render, staticRenderFns } from "./BsGridCellNumbering.vue?vue&type=template&id=59260634&scoped=true&"
import script from "./BsGridCellNumbering.vue?vue&type=script&lang=js&"
export * from "./BsGridCellNumbering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59260634",
  null
  
)

export default component.exports